{
  "Accessibility Menu": "Accessibility Menu",
  "Reset settings": "Reset settings",
  "Close": "Close",
  "Content Adjustments": "Content Adjustments",
  "Adjust Font Size": "Adjust Font Size",
  "Highlight Title": "Highlight Title",
  "Highlight Links": "Highlight Links",
  "Readable Font": "Readable Font",
  "Color Adjustments": "Color Adjustments",
  "Dark Contrast": "Dark Contrast",
  "Light Contrast": "Light Contrast",
  "High Contrast": "High Contrast",
  "High Saturation": "High Saturation",
  "Low Saturation": "Low Saturation",
  "Monochrome": "Monochrome",
  "Tools": "Tools",
  "Reading Guide": "Reading Guide",
  "Stop Animations": "Stop Animations",
  "Big Cursor": "Big Cursor",
  "Increase Font Size": "Increase Font Size",
  "Decrease Font Size": "Decrease Font Size",
  "Letter Spacing": "Letter Spacing",
  "Line Height": "Line Height",
  "Font Weight": "Font Weight",
  "Dyslexia Font": "Dyslexia Font",
  "Language": "Language",
  "Open Accessibility Menu": "Open Accessibility Menu",
  "Screen Reader": "Screen Reader",
  "Male": "Male",
  "Female": "Female"
}
